import axios, { AxiosError, AxiosResponse } from "axios";
import { Alert } from "components";
import { urlApp } from "constants/AppUrl";
import { getStoreData, getStoreToken } from "utils/storage";
import { Log, PostMSG } from "utils/utils";
const baseURL = urlApp.APIURL;
const axiosApp = axios.create({
  baseURL: baseURL + "api/",
  timeout: 10000,
});
const axiosAppV3 = axios.create({
  baseURL: urlApp.APIURLV3 + "api/",
  timeout: 10000,
});
const axiosAppV3TypeText = axios.create({
  baseURL: urlApp.APIURLV3 + "api/",
  timeout: 10000,
});
const axiosTextTypeV3 = axios.create({
  baseURL: urlApp.APIURLV3 + "api/",
  timeout: 10000,
});

const aa = axios.create({
  baseURL: baseURL + "api/",
  timeout: 10000,
});

const tempToken = "token";

function logCurl(config: any) {
  const { method, url, headers, data } = config;
  const baseUrl = config.baseURL || "";
  const fullUrl = `${baseUrl}${url}`;
  let curl = `curl -X ${method?.toUpperCase()} '${fullUrl}'`;

  const ignoredKeys = [
    "common",
    "get",
    "post",
    "put",
    "patch",
    "delete",
    "head",
  ];

  Object.entries(headers).forEach(([key, value]) => {
    if (!ignoredKeys.includes(key)) {
      curl += ` \\\n  -H '${key}: ${value}'`;
    }
  });

  curl += ` \\\n  -H 'Origin: https://daiichi.mobile'`;

  // multipart body
  if (data instanceof FormData) {
    // FormData không đọc trực tiếp được
    // chỉ log placeholder cho file
    curl += ` \\\n  -F 'file=@<file>'`;
  } else if (data) {
    curl += ` \\\n  -d '${
      typeof data === "string" ? data : JSON.stringify(data)
    }'`;
  }

  Log(curl);
}

const functionAuthen = (err) => {
  if (err.status == 401) {
    Alert.showError({
      content: err.message,
      multilanguage: false,
      type: 2,
      onClose: () => {
        PostMSG("RequestAuthenFailure", {});
      },
      onConfirm: () => {
        PostMSG("RequestAuthenFailure", {});
      },
    });
    return;
  }
};

axiosApp.interceptors.request.use(
  async (config: any) => {
    const refCode = await getStoreData("refCode");
    const mToken = await getStoreToken();
    const idCode = await getStoreData("idCode");
    const idNo = await getStoreData("idNo");
    const phone = await getStoreData("phone");
    config.headers["Authorization"] = `Bearer ${mToken || tempToken}`;
    config.headers["phone"] = phone;
    config.headers["idNo"] = idNo;
    config.headers["refCode"] = refCode;
    config.headers["idCode"] = idCode;
    config.headers["Content-Type"] = "application/json";
    Log("===Curl===");
    logCurl(config);
    Log("===End===");
    return config;
  },
  (error: any) => Promise.reject(error),
);

axiosAppV3.interceptors.request.use(
  async (config: any) => {
    const refCode = await getStoreData("refCode");
    const mToken = await getStoreToken();
    const idCode = await getStoreData("idCode");
    const phone = await getStoreData("phone");
    const idNo = await getStoreData("idNo");
    config.headers["Authorization"] = `Bearer ${mToken || tempToken}`;
    config.headers["phone"] = phone;
    config.headers["idNo"] = idNo;
    config.headers["refCode"] = refCode;
    config.headers["idCode"] = idCode;
    config.headers["Content-Type"] = "application/json";
    Log("===Curl===");
    logCurl(config);
    Log("===End===");
    return config;
  },
  (error: any) => Promise.reject(error),
);

axiosAppV3TypeText.interceptors.request.use(
  async (config: any) => {
    const refCode = await getStoreData("refCode");
    const mToken = await getStoreToken();
    const idCode = await getStoreData("idCode");
    const phone = await getStoreData("phone");
    const idNo = await getStoreData("idNo");
    config.headers["Authorization"] = `Bearer ${mToken || tempToken}`;
    config.headers["Content-Type"] = "application/json; charset=utf-8";
    config.headers["phone"] = phone;
    config.headers["idNo"] = idNo;
    config.headers["refCode"] = refCode;
    config.headers["idCode"] = idCode;
    Log("===Curl===");
    logCurl(config);
    Log("===End===");
    return config;
  },
  (error: any) => Promise.reject(error),
);

axiosTextTypeV3.interceptors.request.use(
  async (config: any) => {
    const refCode = await getStoreData("refCode");
    const mToken = await getStoreToken();
    const idCode = await getStoreData("idCode");
    const phone = await getStoreData("phone");
    const idNo = await getStoreData("idNo");
    config.headers["Authorization"] = `Bearer ${mToken || tempToken}`;
    config.headers["Content-Type"] = "text/plain";
    config.headers["phone"] = phone;
    config.headers["idNo"] = idNo;
    config.headers["refCode"] = refCode;
    config.headers["idCode"] = idCode;
    Log("===Curl===");
    logCurl(config);
    Log("===End===");
    return config;
  },
  (error: any) => Promise.reject(error),
);

aa.interceptors.request.use(
  async (config: any) => {
    const refCode = await getStoreData("refCode");
    const mToken = await getStoreToken();
    const idCode = await getStoreData("idCode");
    const phone = await getStoreData("phone");
    const idNo = await getStoreData("idNo");
    config.headers["Authorization"] = `Bearer ${mToken || tempToken}`;
    config.headers["Content-Type"] = "multipart/form-data";
    config.headers["Accept"] = "application/json";
    config.headers["idCode"] = idCode;
    config.headers["phone"] = phone;
    config.headers["idNo"] = idNo;
    config.headers["refCode"] = refCode;
    Log("===Curl===");
    logCurl(config);
    Log("===End===");
    return config;
  },
  (error: any) => Promise.reject(error),
);

aa.interceptors.response.use(
  (res: AxiosResponse<{ content: any; message: string; result: number }>) => {
    return res;
  },
  (
    err: AxiosError<{
      data?: {
        message?: string;
        messageEn?: string;
        content?: any;
        data?: any;
        result?: number;
      };
    }>,
  ) => {
    throw (
      err.response?.data || {
        message: "Lỗi mạng",
        messageEn: "Lỗi mạng",
        content: null,
        result: -1,
        data: null,
      }
    );
  },
);

axiosApp.interceptors.response.use(
  (res: AxiosResponse<{ content: any; message: string; result: number }>) => {
    return res;
  },
  (
    err: AxiosError<{
      data?: {
        message?: string;
        content?: any;
        data?: any;
        result?: number;
      };
    }>,
  ) => {
    throw (
      err.response?.data || {
        message: "",
        content: null,
        result: -1,
        data: null,
      }
    );
  },
);

axiosAppV3.interceptors.response.use(
  (res: AxiosResponse<{ content: any; message: string; result: number }>) => {
    return res;
  },
  (
    err: AxiosError<{
      data?: {
        message?: string;
        content?: any;
        data?: any;
        result?: number;
      };
    }>,
  ) => {
    throw (
      err.response?.data || {
        message: "",
        content: null,
        result: -1,
        data: null,
      }
    );
  },
);

axiosAppV3TypeText.interceptors.response.use(
  (res: AxiosResponse<{ content: any; message: string; result: number }>) => {
    return res;
  },
  (
    err: AxiosError<{
      data?: {
        message?: string;
        content?: any;
        data?: any;
        result?: number;
      };
    }>,
  ) => {
    throw (
      err.response?.data || {
        message: "",
        content: null,
        result: -1,
        data: null,
      }
    );
  },
);

axiosTextTypeV3.interceptors.response.use(
  (res: AxiosResponse<{ content: any; message: string; result: number }>) => {
    return res;
  },
  (
    err: AxiosError<{
      data?: {
        message?: string;
        content?: any;
        data?: any;
        result?: number;
      };
    }>,
  ) => {
    throw (
      err.response?.data || {
        message: "",
        content: null,
        result: -1,
        data: null,
      }
    );
  },
);

export async function doGetAxios(url: string): Promise<any> {
  try {
    const res: AxiosResponse = await axiosApp.get(url);
    if (res) {
      return res.data;
    }
    throw res;
  } catch (error: any) {
    if (error.status != 401) {
      throw error;
    }
    functionAuthen(error);
    return;
  }
}

export async function doPostAxios(url: string, params: object): Promise<any> {
  try {
    const res: AxiosResponse = await axiosApp.post(url, JSON.stringify(params));
    if (res) {
      return res.data;
    }
    throw res;
  } catch (error: any) {
    if (error.status != 401) {
      throw error;
    }
    functionAuthen(error);
    return;
  }
}
export async function doPostAxiosV3(url: string, params: object): Promise<any> {
  try {
    const res: AxiosResponse = await axiosAppV3.post(
      url,
      JSON.stringify(params),
    );
    if (res) {
      return res.data;
    }
    throw res;
  } catch (error: any) {
    if (error.status != 401) {
      throw error;
    }
    functionAuthen(error);
    return;
  }
}
export async function doPostAxiosV3TypeText(
  url: string,
  params: object | any,
): Promise<any> {
  try {
    const res: AxiosResponse = await axiosAppV3TypeText.post(url, params);
    if (res) {
      return res.data;
    }
    throw res;
  } catch (error: any) {
    if (error.status != 401) {
      throw error;
    }
    functionAuthen(error);
    return;
  }
}

export async function postTextTypeV3(
  url: string,
  params: object | any,
): Promise<any> {
  try {
    const res: AxiosResponse = await axiosTextTypeV3.post(url, params);
    if (res) {
      return res.data;
    }
    throw res;
  } catch (error: any) {
    if (error.status != 401) {
      throw error;
    }
    functionAuthen(error);
    return;
  }
}

export async function axiosMultipart(
  url: string,
  params: any,
): Promise<AxiosResponse | any> {
  try {
    const res: AxiosResponse = await aa.post(url, params);
    if (res) {
      return res.data;
    }
    throw res;
  } catch (error: any) {
    if (error.status != 401) {
      throw error;
    }
    functionAuthen(error);
    return;
  }
}
export async function axiosGetData(url: string): Promise<AxiosResponse | any> {
  try {
    const res: AxiosResponse = await aa.get(url);
    if (res) {
      return res.data;
    }
    throw res;
  } catch (error: any) {
    if (error.status != 401) {
      throw error;
    }
    functionAuthen(error);
    return;
  }
}
